import { makeStyles } from "@material-ui/core";
export default makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(5),
  },
  btn: {
    marginTop: theme.spacing(2),
  },
  form: {
    maxWidth: 300,
    display: "block",
    margin: "0 auto 10px auto",
    paddingBottom: theme.spacing(5),
  },
}));
